import { INewAccount, INewMeasure } from './interfaces/interfaces';
import validator from 'validator';
import { notify } from '../notifications/notification';
import { dateIsOld, tomorrow } from './date';

const validatePrimaryAccount = (form: INewAccount) => {
  let valid = true;

  if (validator.isEmpty(form.firstName)) {
    notify('Nu ați completat numele de familie.', 'warning');
    valid = false;
  }

  if (validator.isEmpty(form.lastName)) {
    notify('Nu ați completat prenumele.', 'warning');
    valid = false;
  }

  if (!validator.isEmail(form.email)) {
    notify('Adresa de email nu este corectă.', 'warning');
    valid = false;
  }

  if (!validator.isMobilePhone(form.phone, 'ro-RO')) {
    notify(
      'Numărul de telefon nu este completat corect. Va rugăm, încercați din nou cu un număr cu format 07XXXXXXXX.',
      'warning'
    );
    valid = false;
  }

  if (validator.isEmpty(form.institutionName!)) {
    notify('Nu ați completat numele instituției.', 'warning');
    valid = false;
  }

  if (!new Date(form.contractExpirationDate)) {
    notify('Nu ați completat data expirării contractului.', 'warning');
    valid = false;
  }

  if (dateIsOld(form.contractExpirationDate)) {
    notify(
      `Data expirării contractului nu poate fi mai veche de ${tomorrow()}.`,
      'warning'
    );
    valid = false;
  }

  return valid;
};

const validateSecondaryAccount = (form: INewAccount) => {
  let valid = true;

  if (validator.isEmpty(form.firstName)) {
    notify('Nu ați completat numele de familie.', 'warning');
    valid = false;
  }

  if (validator.isEmpty(form.lastName)) {
    notify('Nu ați completat prenumele.', 'warning');
    valid = false;
  }

  if (!validator.isEmail(form.email)) {
    notify('Adresa de email nu este corectă.', 'warning');
    valid = false;
  }

  if (!validator.isMobilePhone(form.phone, 'ro-RO')) {
    notify(
      'Numărul de telefon nu este completat corect. Va rugăm, încercați din nou cu un număr cu format 07XXXXXXXX.',
      'warning'
    );
    valid = false;
  }

  return valid;
};

const validateMeasure = (measure: INewMeasure) => {
  let valid = true;

  if (validator.isEmpty(measure.description)) {
    notify('Nu ați completat descrierea.', 'warning');
    valid = false;
  }

  if (validator.isEmpty(measure.number)) {
    notify('Nu ați completat numărul.', 'warning');
    valid = false;
  }

  if (validator.isEmpty(measure.responsiblePerson)) {
    notify('Nu ați completat responsabilul.', 'warning');
    valid = false;
  }

  if (!new Date(measure.originalDeadline)) {
    notify('Nu ați completat data.', 'warning');
    valid = false;
  }

  return valid;
};

export { validatePrimaryAccount, validateSecondaryAccount, validateMeasure };
